export { default as VendorsEditTemplate } from './VendorsEditTemplate';
export { default as VendorsListTemplate } from './VendorsListTemplate';
